// extracted by mini-css-extract-plugin
export default {"dropdownIcon":"AntdSelect_dropdownIcon__pHuXU","reverse":"AntdSelect_reverse__jrUTS"};